// // import React from 'react';
// // import { ApolloProvider } from '@apollo/client';
// // import 'bootstrap/dist/css/bootstrap.min.css';
// // import AuthProvider from 'contexts/AuthContext';
// // import FSBToastify from 'components/common/FSBToastify';
// // import { NotificationProvider } from 'contexts/NotificationProvider';
// // import { createRoot } from 'react-dom/client';
// // import { Provider } from 'react-redux';
// // import { store } from './store';
// // import App from './App';
// // import reportWebVitals from './reportWebVitals';
// // import client from './config/apollo';
// // import 'font-awesome/css/font-awesome.min.css';
// // import 'react-toastify/dist/ReactToastify.css';
// // // import 'react-bootstrap-typeahead/css/Typeahead.css';
// // import './index.scss';

// // createRoot(document.getElementById('root')).render(
// //   <Provider store={store}>
// //     <AuthProvider>
// //       <ApolloProvider client={client}>
// //         <NotificationProvider>
// //           <App />
// //           <FSBToastify />
// //         </NotificationProvider>
// //       </ApolloProvider>
// //     </AuthProvider>{' '}
// //   </Provider>,
// // );

// // // If you want to start measuring performance in your app, pass a function
// // // to log results (for example: reportWebVitals(console.log))
// // // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// // reportWebVitals();

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js').then(registration => {
//       console.log('SW registered: ', registration);
//     }).catch(registrationError => {
//       console.log('SW registration failed: ', registrationError);
//     });
//   });
// }

// import React from 'react';
// import { ApolloProvider } from '@apollo/client';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { createRoot } from 'react-dom/client';
// import { Provider } from 'react-redux';
// import 'font-awesome/css/font-awesome.min.css';
// import 'react-toastify/dist/ReactToastify.css';
// // import 'react-bootstrap-typeahead/css/Typeahead.css';
// import AuthProvider from 'contexts/AuthContext';
// import { NotificationProvider } from 'contexts/NotificationProvider';
// import RoleConfigProvider from 'contexts/RoleConfigContext';
// import FSBToastify from 'components/common/FSBToastify';
// import { store } from './store';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import client from './config/apollo';
// import './index.scss';

// createRoot(document.getElementById('root')).render(
//   <Provider store={store}>
//     <AuthProvider>
//       <ApolloProvider client={client}>
//         <NotificationProvider>
//           <RoleConfigProvider>
//             <App />
//           </RoleConfigProvider>

//           <FSBToastify />
//         </NotificationProvider>
//       </ApolloProvider>
//     </AuthProvider>
//   </Provider>,
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from 'react';
import { ApolloProvider } from '@apollo/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import 'font-awesome/css/font-awesome.min.css';
import 'react-toastify/dist/ReactToastify.css';
// import 'react-bootstrap-typeahead/css/Typeahead.css';
import AuthProvider from 'contexts/AuthContext';
import { NotificationProvider } from 'contexts/NotificationProvider';
import RoleConfigProvider from 'contexts/RoleConfigContext';
import FSBToastify from 'components/common/FSBToastify';
import { store } from './store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import client from './config/apollo';
import './index.scss';

// ✅ Service worker registration AFTER imports
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        // eslint-disable-next-line no-console
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        // eslint-disable-next-line no-console
        console.log('SW registration failed: ', registrationError);
      });
  });
}

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <AuthProvider>
      <ApolloProvider client={client}>
        <NotificationProvider>
          <RoleConfigProvider>
            <App />
          </RoleConfigProvider>
          <FSBToastify />
        </NotificationProvider>
      </ApolloProvider>
    </AuthProvider>
  </Provider>,
);

reportWebVitals();
